import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSettingsColored = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M22.1256 8.8417C21.746 6.3861 18.2542 6.3861 17.8747 8.8417C17.6129 10.5357 15.6108 11.2737 14.335 10.1464C12.4856 8.51234 9.81072 10.7853 11.0787 12.9134C11.9533 14.3815 10.888 16.2501 9.1952 16.217C6.74128 16.1691 6.13494 19.6515 8.45705 20.4564C10.059 21.0116 10.4289 23.1365 9.11117 24.2131C7.20094 25.7737 8.94684 28.8361 11.2366 27.9411C12.8162 27.3237 14.4483 28.7106 14.1222 30.3931C13.6495 32.8321 16.9307 34.0415 18.1167 31.8654C18.9348 30.3643 21.0655 30.3643 21.8836 31.8654C23.0696 34.0415 26.3508 32.8321 25.8781 30.3931C25.552 28.7106 27.1841 27.3237 28.7637 27.9411C31.0534 28.8361 32.7993 25.7737 30.8891 24.2131C29.5713 23.1365 29.9413 21.0116 31.5432 20.4564C33.8653 19.6515 33.259 16.1691 30.8051 16.217C29.1123 16.2501 28.0469 14.3815 28.9216 12.9134C30.1896 10.7853 27.5147 8.51234 25.6653 10.1464C24.3895 11.2737 22.3874 10.5357 22.1256 8.8417ZM19.997 28.7456C24.5859 28.7456 28.3059 24.9784 28.3059 20.3313C28.3059 15.6843 24.5859 11.9171 19.997 11.9171C15.4082 11.9171 11.6882 15.6843 11.6882 20.3313C11.6882 24.9784 15.4082 28.7456 19.997 28.7456Z",
		fill: "url(#paint0_angular_320_31593)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("radialGradient", {
		id: "paint0_angular_320_31593",
		cx: 0,
		cy: 0,
		r: 1,
		gradientUnits: "userSpaceOnUse",
		gradientTransform: "translate(20.0001 20) rotate(-32.6195) scale(16.0774 16.0774)",
		children: [
			/* @__PURE__ */ _jsx("stop", {
				offset: .00183952,
				stopColor: "#53BCDE"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .368179,
				stopColor: "#767CFF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: .645971,
				stopColor: "#AC8EFF"
			})
		]
	}) })]
});
export default SvgSettingsColored;
